export function getFinalDestinationEmail(destinationEmail, getDestinationEmail) {
  var finalDestinationEmail = destinationEmail;

  if (!destinationEmail && getDestinationEmail) {
    finalDestinationEmail = getDestinationEmail();
  }

  return finalDestinationEmail;
}